// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:55:02
import { FileDescriptorHistory_abstract } from './../abstract/SagaSchema/FileDescriptorHistory_abstract';
export class FileDescriptorHistory extends FileDescriptorHistory_abstract {}
